import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AuthenticationService } from '../../services';
import { UpdateUserDto } from 'src/app/domain/models/dto/update-user.dto';
import { MatSidenav } from '@angular/material/sidenav';
import { NotifierService } from 'angular-notifier';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
  private readonly notifier: NotifierService;
  user: UpdateUserDto;
  userLogin: string;
  tenant: string = '';
  merchant: string = '';
  isExpanded = true;
  @ViewChild('sidenav') sidenav: MatSidenav;
  showSubmenu: boolean = false;
  showSubmenuEnviar: boolean = false;
  showSubmenuReceber: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  isMobile: boolean;
  showMenu = true;
  openMobileMenu: boolean;
  constructor(
    public router: Router,

    private readonly route: ActivatedRoute,
    private readonly merchantService: MerchantService,
    notifierService: NotifierService,
    public tenantService: TenantGeneralService,
    private readonly userService: UserService,
    private readonly authService: AuthenticationService
  ) {
    this.userLogin = this.authService.getCurrentUserId();
    this.notifier = notifierService;
  }

  get companyId() {
    return +this.authService.getCompanyId();
  }

  get individualId() {
    return +this.authService.getIndividualId();
  }

  ngOnInit(): void {
    this.merchant = this.merchantService.getUserMerchant();
    if (window.innerWidth < 830) {
      this.isMobile = true;
      this.showMenu = false;
    } else {
      this.isMobile = false;
    }

    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });

    this.userService.getPeople(this.userLogin).subscribe((getResult) => {
      this.user = new UpdateUserDto(getResult.data);
    });

    // Manter submenus abertos quando uma opção estiver selecionada
    this.updateSubmenuState();
    this.router.events.subscribe(() => {
      this.updateSubmenuState();
    });
  }

  updateSubmenuState(): void {
    // Abre o submenu Enviar se alguma opção de Outbound estiver ativa
    if (this.router.url.includes('/admin/home/1')) {
      this.showSubmenuEnviar = true;
    }
    // Abre o submenu Receber se alguma opção de Inbound estiver ativa
    if (this.router.url.includes('/admin/home/0')) {
      this.showSubmenuReceber = true;
    }
  }

  logout() {
    localStorage.clear();
    this.router.url.includes('admin')
      ? this.router.navigateByUrl(
          `${this.tenant}/admin/login?m=${this.merchant}`
        )
      : this.router.navigateByUrl(`${this.tenant}/login?m=${this.merchant}`);
  }

  goToInbound() {
    this.router.navigate([`${this.tenant}/orders`, '0']);
  }

  goToHome() {
    this.router.url.includes('admin')
      ? this.router.navigate([`${this.tenant}/admin/home`])
      : this.router.navigate([`${this.tenant}/home`]);
  }

  goToOutbound() {
    this.router.navigate([`${this.tenant}/orders`, '1']);
  }

  goToAccount() {
    this.router.navigate([`${this.tenant}/account`]);
  }

  goToSavedContacts() {
    this.router.navigate([`${this.tenant}/saved-contacts`]);
  }

  goToClients() {
    this.router.navigate([`${this.tenant}/admin/clients`]);
  }

  goToPartners() {
    this.router.navigate([`${this.tenant}/admin/partners`]);
  }

  goToPartnerDocuments() {
    this.router.navigate([`${this.tenant}/admin/clients/partner-document`]);
  }

  goToOutboundAdmin() {
    this.router.navigate([`${this.tenant}/admin/home`, '1']);
  }

  goToOrdersHistory() {
    this.router.navigate([`${this.tenant}/admin/orders-history`]);
  }

  goToInboundAdmin() {
    this.router.navigate([`${this.tenant}/admin/home`, '0']);
  }

  goToManageQuotation() {
    this.router.navigate([`${this.tenant}/admin/manage-quotation`]);
  }

  // Métodos Enviar (Outbound)
  goToOutboundAdminPendencia() {
    this.router.navigate([`${this.tenant}/admin/home`, '1'], {
      queryParams: { status: 'pendencia' },
    });
  }

  // Métodos Receber (Inbound)
  goToInboundAdminPendencia() {
    this.router.navigate([`${this.tenant}/admin/home`, '0'], {
      queryParams: { status: 'pendencia' },
    });
  }

  goToInboundAdminLiquidadas() {
    this.router.navigate([`${this.tenant}/admin/home`, '0'], {
      queryParams: { status: 'liquidadas' },
    });
  }

  // Métodos para verificar submenu ativo - Outbound
  isActiveOutboundEmAndamento(): boolean {
    return (
      this.router.url.includes('/admin/home/1') &&
      !this.router.url.includes('status=')
    );
  }

  isActiveOutboundPendencia(): boolean {
    return (
      this.router.url.includes('/admin/home/1') &&
      this.router.url.includes('status=pendencia')
    );
  }

  isActiveOutboundLiquidadas(): boolean {
    return (
      this.router.url.includes('/admin/home/1') &&
      this.router.url.includes('status=liquidadas')
    );
  }

  // Métodos para verificar submenu ativo - Inbound
  isActiveInboundEmAndamento(): boolean {
    return (
      this.router.url.includes('/admin/home/0') &&
      !this.router.url.includes('status=')
    );
  }

  isActiveInboundPendencia(): boolean {
    return (
      this.router.url.includes('/admin/home/0') &&
      this.router.url.includes('status=pendencia')
    );
  }

  isActiveInboundLiquidadas(): boolean {
    return (
      this.router.url.includes('/admin/home/0') &&
      this.router.url.includes('status=liquidadas')
    );
  }
}
